import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationDatePluginService } from './installation-date.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-date-edit',
    templateUrl: './installation-date-edit.component.html',
    standalone: false
})
export class InstallationDateEditPageComponent extends BaseInstallationEditPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;

  public currentItem: any;

  private dateToRemove: number;
  private sub = new Subscription();

  @ViewChild('dateDeleteConfirm', { static: true }) dateDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationDatePluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['dates'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateDates(this.inspectionId, this.pointId, this.pluginId, model.dates).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['dates'];
    control.push(this.initDate());
  }

  public cancel() {
    this.goToBack();
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['dates'];
    control.removeAt(this.dateToRemove);
  }

  public openDateDeleteConfirm(i: number) {
    this.dateDeleteConfirm.open();
    this.dateToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      dates: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['dates'];
    _.forEach(this.plugin.config.Dates, (el) => {
      control.push(this.initDate(el));
    });
  }

  private initDate(el?: any) {
    return this.fb.group({
      label: new UntypedFormControl(el?.Label ?? ''),
      dateValue: new UntypedFormControl(el?.DateValue ?? ''),
      numberOfDaysAfter: new UntypedFormControl(el?.NumberOfDaysAfter ? parseInt(el.NumberOfDaysAfter) : ''),
      milestone: new UntypedFormControl(el?.Milestone ?? ''),
      comment: new UntypedFormControl(el?.Comment ?? '')
    });
  }
}
